module.exports = __webpack_public_path__ + "static/media/left-arrow.5a4f28c4.svg";